import _ from 'lodash';

export const getCustomerProfileUsenameConfig = (state: {}) => {
  return _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.emma-customer-profile.resetUsenameLabels`,
  );
};

export const getCustomerProfileUsenameEmail = (state: {}) => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.customerResetUserName.email`,
    '',
  );
};

export const getCustomerProfileUsenameMobile = (state: {}) => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.customerResetUserName.mobile`,
    '',
  );
};

export const getCustomerProfileUsenameSubmitLoading = (state: {}) => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.customerResetUserName.isSubmitLoading`,
    false,
  );
};

export const getCustomerProfileUsenameCurTab = (state: {}) => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.customerResetUserName.curUserNameTab`,
    '',
  );
};

export const getCustomerProfileResetApi = (state: {}) => {
  return _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.emma-customer-profile.customerProfileApi.resetSubmitUserNamePasswordApi`,
    '',
  );
};
